/**
 * Account-manager email-sender credentials (Spring API).
 * Lets an AM store the mailbox their seller notifications are sent FROM.
 * `apiClient` injects the auth token and returns response.data (camelCased).
 */
import apiClient from './api/client';

const BASE = '/api/account-manager/email-sender';

const amEmailSenderService = {
  // ── Self-service (current account manager) ──
  /** → CredentialStatus | null */
  getStatus: () => apiClient.get(BASE),
  /** → ValidationResult { valid, message } */
  save: (email, password) => apiClient.put(BASE, { email, password }),
  /** Send a test email to `to` (defaults to self when omitted). → ValidationResult */
  sendTest: (to) => apiClient.post(`${BASE}/test`, null, { params: to ? { to } : {} }),
  remove: () => apiClient.delete(BASE),

  // ── Admin override (manage another AM) ──
  /** → [{ userId, email, validated, enabled, validatedAt }] (admin/management only) */
  getAll: () => apiClient.get(`${BASE}/all`),
  getStatusFor: (userId) => apiClient.get(`${BASE}/${userId}`),
  saveFor: (userId, email, password) => apiClient.put(`${BASE}/${userId}`, { email, password }),
  sendTestFor: (userId, to) =>
    apiClient.post(`${BASE}/${userId}/test`, null, { params: to ? { to } : {} }),
  removeFor: (userId) => apiClient.delete(`${BASE}/${userId}`),
};

export default amEmailSenderService;
